<template>
	<div class="link-us">
		<div class="inner-img">
			<top-image :myimg="myimg" :activecolor="activecolor"></top-image>
		</div>
		<div class="location">
			<img class="location-img" src="./1.jpg"/>
			<div class="whitebg">
				<span :class="'a' + index" class="locationword" v-for="(item, index) in locationword">{{item}}</span>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
import TopImage from 'components/top-image/top-image'

export default {
	data() {
		return {
			myimg: 'link-us',
			activecolor: 'grey'
		}
	},
	methods: {
	},
	computed: {
		locationword() {
			return this.$t('locationword')
		}
	},
	components: {
		TopImage
	}
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.location
		width: 60%
		margin: 50px auto
		position: relative
		@media screen and (max-width:550px)
			width: 80%
			margin: 20% auto
		.location-img
			width: 100%
		.whitebg
			position: absolute 
			top: 10px
			right: 10px
			width: 40%
			background: $color-background
			@media screen and (max-width:550px)
				position: static
				width: 100%
			&:before
				position: absolute 
				top: 10%
				content: ''
				width: 4px
				height: 20px
				background: red
			.locationword
				display: block
				font-size: $font-web-small-s
				line-height: $font-web-small
				margin-top: 8px
				padding: 0 20px
				@media screen and (max-width:550px)
					line-height: $font-web-small-ss
					padding: 3px 10px
			.a0
				margin-top: 20px
				@media screen and (max-width:550px)
					padding-top: 20px
			.a3
				margin-bottom: 20px
				@media screen and (max-width:550px)
					padding-bottom: 20px
</style>	



// WEBPACK FOOTER //
// src/components/link-us/link-us.vue